import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { connect } from "react-redux";
import { updateEventAccessType } from "store/actions";

const ExperienceAccess = ({ selectedEvent, updateEventAccessType }) => {
  // Local state for access_type
  const [accessType, setAccessType] = useState(selectedEvent?.access_type || 3);

  // Sync local state with selectedEvent when component mounts or selectedEvent changes
  useEffect(() => {
    if (selectedEvent?.access_type) {
      setAccessType(selectedEvent.access_type);
    }
  }, [selectedEvent]);

  // Handle radio button change
  const handleChange = (event) => {
    const value = parseInt(event.target.value);
    setAccessType(value);
    updateEventAccessType({
      ...selectedEvent,
      access_type: value,
    });
  };

  return (
    <Row className="mt-3">
      <Col xs={12}>
        <h5>Who would you like to access this experience?</h5>
      </Col>
      <Col xs={12} className="mx-3 my-3">
        {/* Open Experience */}
        <label>
          <input
            type="radio"
            value="1"
            checked={accessType === 1}
            onChange={handleChange}
          />
          &nbsp;Open Experience -  Allows ALL users in the app to access this experience.
        </label>
        <br />

        {/* Logged In Experience */}
        <label>
          <input
            type="radio"
            value="2"
            checked={accessType === 2}
            onChange={handleChange}
          />
          Logged In Experience - Allows ALL users except for Visitors.
        </label>
        <br />

        {/* Closed Experience */}
        <label>
          <input
            type="radio"
            value="3"
            checked={accessType === 3}
            onChange={handleChange}
          />
          Closed Experience - Grant access by adding tags, uploading emails, or giving out an invite code.
        </label>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state) => ({
  selectedEvent: state.experiences.selectedEvent,
});

const mapDispatchToProps = (dispatch) => ({
  updateEventAccessType: (value) => dispatch(updateEventAccessType(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceAccess);
